import './SkeletonCard.css';

export default function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="sk-image" />
      <div className="sk-body">
        <div className="sk-line sk-vendor" />
        <div className="sk-line sk-name-1" />
        <div className="sk-line sk-name-2" />
        <div className="sk-line sk-stars" />
        <div className="sk-line sk-price" />
      </div>
    </div>
  );
}
